export const errorMessages = {
  cadFiltersFailed: 'CAD Filters were not saved correctly. Please try again.',
};
